var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 860,
    height: 490,
    viewBox: "0 0 860 490",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 27.4039C0.601562 27.4039 7.18727 22.4646 9.07761 14.4154C10.968 6.36619 17.9805 1.00006 17.9805 1.00006",
    stroke: "url(#paint0_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 49.3562C0.601562 49.3562 23.1637 42.4047 29.1396 24.9037C34.8716 7.89066 58.0436 1.00006 58.0436 1.00006",
    stroke: "url(#paint1_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 71.3086C0.601562 71.3086 39.1402 62.3447 49.1407 35.4531C58.7753 9.53709 98.1066 1.00006 98.1066 1.00006",
    stroke: "url(#paint2_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 93.3219C0.601562 93.3219 55.0556 82.2848 69.2027 46.0024C82.679 11.1225 138.109 1.00006 138.109 1.00006",
    stroke: "url(#paint3_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 115.274C0.601562 115.274 71.0321 102.225 89.2037 56.5517C106.583 12.769 178.172 1.00006 178.172 1.00006",
    stroke: "url(#paint4_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 137.227C0.601562 137.227 87.0085 122.165 109.266 67.0401C130.486 14.4154 218.235 1.00006 218.235 1.00006",
    stroke: "url(#paint5_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 159.24C0.601562 159.24 102.924 142.105 129.267 77.6504C154.39 16.0008 258.298 1.00006 258.298 1.00006",
    stroke: "url(#paint6_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 181.192C0.601562 181.192 118.9 162.045 149.329 88.1387C178.294 17.6473 298.361 1.00006 298.361 1.00006",
    stroke: "url(#paint7_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 203.145C0.601562 203.145 134.877 181.985 169.391 98.6881C202.197 19.2937 338.363 1.00006 338.363 1.00006",
    stroke: "url(#paint8_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 225.158C0.601562 225.158 150.792 201.986 189.392 109.237C226.162 20.8791 378.426 1.00006 378.426 1.00006",
    stroke: "url(#paint9_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 247.11C0.601562 247.11 166.769 221.865 209.454 119.787C250.066 22.5256 418.489 1.00006 418.489 1.00006",
    stroke: "url(#paint10_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 269.063C0.601562 269.063 182.745 241.805 229.455 130.275C273.969 24.172 458.552 1.00006 458.552 1.00006",
    stroke: "url(#paint11_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 291.076C0.601562 291.076 198.661 261.806 249.517 140.885C297.873 25.7574 498.554 1.00006 498.554 1.00006",
    stroke: "url(#paint12_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 313.029C0.601562 313.029 214.637 281.746 269.518 151.435C321.777 27.4039 538.617 1.00006 538.617 1.00006",
    stroke: "url(#paint13_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 335.042C0.601562 335.042 230.614 301.686 289.58 161.984C345.681 29.0503 578.68 1.00006 578.68 1.00006",
    stroke: "url(#paint14_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 356.994C0.601562 356.994 246.529 321.627 309.581 172.533C369.584 30.6357 618.744 1.00006 618.744 1.00006",
    stroke: "url(#paint15_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 378.947C0.601562 378.947 262.505 341.567 329.643 183.022C393.488 32.2822 658.807 1.00006 658.807 1.00006",
    stroke: "url(#paint16_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 400.96C0.601562 400.96 278.482 361.507 349.705 193.632C417.392 33.9286 698.809 1.00006 698.809 1.00006",
    stroke: "url(#paint17_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 422.912C0.601562 422.912 294.397 381.447 369.706 204.12C441.295 35.5141 738.872 1.00006 738.872 1.00006",
    stroke: "url(#paint18_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 444.865C0.601562 444.865 310.374 401.387 389.768 214.67C465.199 37.1605 778.935 1.00006 778.935 1.00006",
    stroke: "url(#paint19_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 466.878C0.601562 466.878 326.35 421.388 409.769 225.219C489.103 38.8069 818.998 1.00006 818.998 1.00006",
    stroke: "url(#paint20_linear_2073_481)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 488.83C0.601562 488.83 342.266 441.267 429.831 235.768C513.006 40.3924 859 1.00006 859 1.00006",
    stroke: "url(#paint21_linear_2073_481)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2073_481",
    x1: 9.29104,
    y1: 1.00006,
    x2: 9.29104,
    y2: 27.4039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2073_481",
    x1: 29.3226,
    y1: 1.00006,
    x2: 29.3226,
    y2: 49.3562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2073_481",
    x1: 49.3541,
    y1: 1.00006,
    x2: 49.3541,
    y2: 71.3086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2073_481",
    x1: 69.3551,
    y1: 1.00006,
    x2: 69.3551,
    y2: 93.3219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2073_481",
    x1: 89.3867,
    y1: 1.00006,
    x2: 89.3867,
    y2: 115.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2073_481",
    x1: 109.418,
    y1: 1.00006,
    x2: 109.418,
    y2: 137.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2073_481",
    x1: 129.45,
    y1: 1.00006,
    x2: 129.45,
    y2: 159.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2073_481",
    x1: 149.481,
    y1: 1.00006,
    x2: 149.481,
    y2: 181.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2073_481",
    x1: 169.482,
    y1: 1.00006,
    x2: 169.482,
    y2: 203.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2073_481",
    x1: 189.514,
    y1: 1.00006,
    x2: 189.514,
    y2: 225.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2073_481",
    x1: 209.545,
    y1: 1.00006,
    x2: 209.545,
    y2: 247.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2073_481",
    x1: 229.577,
    y1: 1.00006,
    x2: 229.577,
    y2: 269.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2073_481",
    x1: 249.578,
    y1: 1.00006,
    x2: 249.578,
    y2: 291.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2073_481",
    x1: 269.609,
    y1: 1.00006,
    x2: 269.609,
    y2: 313.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2073_481",
    x1: 289.641,
    y1: 1.00006,
    x2: 289.641,
    y2: 335.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2073_481",
    x1: 309.673,
    y1: 1.00006,
    x2: 309.673,
    y2: 356.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2073_481",
    x1: 329.704,
    y1: 1.00006,
    x2: 329.704,
    y2: 378.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2073_481",
    x1: 349.705,
    y1: 1.00006,
    x2: 349.705,
    y2: 400.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2073_481",
    x1: 369.737,
    y1: 1.00006,
    x2: 369.737,
    y2: 422.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2073_481",
    x1: 389.768,
    y1: 1.00006,
    x2: 389.768,
    y2: 444.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2073_481",
    x1: 409.8,
    y1: 1.00006,
    x2: 409.8,
    y2: 466.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2073_481",
    x1: 429.801,
    y1: 1.00006,
    x2: 429.801,
    y2: 488.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup7);
export default __webpack_public_path__ + "static/media/Group (7).2ddd7df720f255ffd9942c0ae0edcec3.svg";
export { ForwardRef as ReactComponent };